import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function EmployerRegister() {
  const [form, setForm] = useState({ company_name: "", contact_name: "", email: "", website: "", password: "", confirm_password: "" });
  const [loading, setLoading] = useState(false);
  const { registerEmployer } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm_password) { toast.error("Passwords do not match"); return; }
    if (form.password.length < 8) { toast.error("Password must be at least 8 characters"); return; }
    setLoading(true);
    try {
      await registerEmployer(form);
      toast.success("Account created. Awaiting admin approval.");
      nav("/employer-portal/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Registration failed");
    } finally { setLoading(false); }
  };

  const onChange = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center p-6 md:p-12">
      <div className="w-full max-w-xl">
        <Link to="/" className="text-xs uppercase tracking-[0.2em] text-ink font-semibold" data-testid="reg-home">← Railway Careers UK</Link>
        <h1 className="font-display font-extrabold text-ink text-3xl md:text-4xl tracking-tight mt-3">Create employer account</h1>
        <p className="text-muted-foreground mt-2 text-sm">Free for UK rail employers. Every new account is manually approved by admin (usually within a working day) to keep the board free of spurious listings.</p>
        <div className="mt-4 rounded-md bg-amber/15 border border-amber/40 px-4 py-3 text-[13px] text-ink">
          <strong>Approval required.</strong> You'll be able to sign in immediately, but you can only post vacancies once we've verified your account. We'll email you the moment you're approved.
        </div>
        <form onSubmit={submit} className="mt-8 grid md:grid-cols-2 gap-5 bg-card border border-border rounded-lg p-7" data-testid="emp-reg-form">
          <div><Label>Company</Label><Input required className="mt-1" value={form.company_name} onChange={onChange("company_name")} data-testid="emp-reg-company" /></div>
          <div><Label>Your name</Label><Input required className="mt-1" value={form.contact_name} onChange={onChange("contact_name")} data-testid="emp-reg-contact" /></div>
          <div className="md:col-span-2"><Label>Work email</Label><Input required type="email" className="mt-1" value={form.email} onChange={onChange("email")} data-testid="emp-reg-email" /></div>
          <div className="md:col-span-2"><Label>Website (optional)</Label><Input className="mt-1" value={form.website} onChange={onChange("website")} data-testid="emp-reg-website" /></div>
          <div><Label>Password (min 8)</Label><Input required type="password" className="mt-1" value={form.password} onChange={onChange("password")} data-testid="emp-reg-password" /></div>
          <div><Label>Confirm password</Label><Input required type="password" className="mt-1" value={form.confirm_password} onChange={onChange("confirm_password")} data-testid="emp-reg-confirm" /></div>
          <Button type="submit" disabled={loading} className="md:col-span-2 bg-navy text-bone hover:bg-lime-600 hover:text-ink font-semibold" data-testid="emp-reg-submit">{loading ? "Creating account…" : "Create account"}</Button>
        </form>
        <div className="mt-4 text-sm text-muted-foreground">Already have one? <Link to="/employer-portal/login" className="text-ink font-semibold underline-offset-4 hover:underline">Sign in →</Link></div>
      </div>
    </div>
  );
}
